import { useCallback } from "react";

import { useOpenModal } from "@/components/modal/utils/openModal";
import { LadyMinV2DTO } from "@/models/lady-dtos";
import { returnOnCondition } from "@/utils/conditionalOutput";

type Params = {
  ladyDtoParam: LadyMinV2DTO;
};

type ReturnType = {
  openModalWithHeader: (
    header: string,
    isOmitHeaderForWord?: boolean,
  ) => () => void;
};

export function useOpenRegisterModal(params: Params): ReturnType;
export function useOpenRegisterModal(): ReturnType;
export function useOpenRegisterModal(params?: Params): ReturnType {
  const { openModal, removeOne } = useOpenModal();

  const openModalWithHeader = useCallback(
    (header: string, isOmitHeaderForWord?: boolean) => () =>
      openModal("PROFILE_ACTION_BUTTONS_MODAL", {
        onClose: removeOne,
        header,
        isOmitHeaderForWord,
        ...returnOnCondition(
          !!params,
          { ladyDtoParam: params?.ladyDtoParam },
          {},
        ),
      }),
    [openModal, params, removeOne],
  );

  return { openModalWithHeader };
}
